// extracted by mini-css-extract-plugin
module.exports = {"close":"PhotoSlide_close__mGCos","image":"PhotoSlide_image__2uSrr","photoButton":"PhotoSlide_photoButton__11VVo","row":"PhotoSlide_row__2CPTs"};